<template>
  <tbody>
  <tr :class="['clickable', { updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <td :data-th="'Název' | translate">
      {{ entity.name }}
    </td>
    <td :data-th="'Jednotka' | translate">
      {{ entity.symbol }}
    </td>
    <td :data-th="'Formátování' | translate">
      {{ entity.format_string }}
    </td>
    <td></td>
  </tr>
  </tbody>
</template>

<script>
import rowActions from "../../mixins/row-actions";

export default {
  name: "CurrenciesRow",
  mixins: [rowActions],
  props: {
    entity: Object,
  },
  data(){
    return{
      detailPageRouteName: "currenciesDetail",
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/currencies/CurrenciesRow.vue